/// <reference types="@shopify/polaris-types" />
import { useState } from "react";
import { useAbandonedCart } from "../../hooks/useAbandonedCart";
import { useShopifySaveBar } from "../../hooks/useShopifySaveBar";

export function AbandonedCartSection() {
  const { enabled, loading, error, toggling, toggle } = useAbandonedCart();
  const [pendingEnabled, setPendingEnabled] = useState<boolean | null>(null);

  useShopifySaveBar({
    isDirty: pendingEnabled !== null,
    isSaving: toggling,
    onSave: async () => {
      try {
        await toggle(pendingEnabled!);
        setPendingEnabled(null);
      } catch {
        // error shown via banner; save bar stays open for retry
      }
    },
    onDiscard: () => setPendingEnabled(null),
  });

  if (loading) {
    return (
      <s-section>
        <s-spinner accessibility-label="Cargando…" />
      </s-section>
    );
  }

  const currentEnabled = pendingEnabled ?? enabled;

  return (
    <s-section>
      {error && (
        <s-banner tone="critical">
          <s-text>{error}</s-text>
        </s-banner>
      )}
      <s-stack direction="block" gap="small-100">
        <s-stack direction="inline" gap="small-200" alignItems="center">
          <s-checkbox
            checked={currentEnabled || undefined}
            disabled={toggling || undefined}
            onChange={(e: Event) =>
              setPendingEnabled((e.target as HTMLInputElement).checked)
            }
          />
          <s-text>Activar Carrito Abandonado</s-text>
          {toggling && <s-spinner accessibility-label="Guardando…" />}
        </s-stack>
        <s-text color="subdued">
          Recupera clientes que abrieron tu formulario COD pero no completaron
          su pedido. Cuando está activo, se enviará un mensaje de seguimiento
          automático para recordarles finalizar su compra.
        </s-text>
      </s-stack>
    </s-section>
  );
}
